import PropTypes from 'prop-types';
import { Button } from 'antd';
import cx from 'classnames';
import { CustomIcon } from '$src/components/CustomIcon';

import './Header.less';

function Header({ hideBack, headerImage, disabled, handleBack, hideClose, children, handleClose, showBackText }) {
  return (
    <div className={cx('step-header__top', { 'step-header__top--with-image': headerImage })}>
      <span>
        {!hideBack && (
          <Button
            size="small"
            type="text"
            shape="circle"
            icon={<CustomIcon type="regular" name="chevron-left.svg" className="step-header__icon" />}
            disabled={disabled}
            onClick={handleBack}
            data-testid="step-header__back"
          >
            {showBackText ? 'Back' : ''}
          </Button>
        )}
      </span>
      {children}
      <span>
        {!hideClose && (
          <Button
            size="small"
            type="text"
            shape="circle"
            icon={<CustomIcon type="regular" name="close.svg" className="step-header__icon" />}
            disabled={disabled}
            onClick={handleClose}
            data-testid="step-header__close"
          />
        )}
      </span>
    </div>
  );
}

Header.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  disabled: PropTypes.bool,
  hideBack: PropTypes.bool,
  hideClose: PropTypes.bool,
  handleClose: PropTypes.func,
  showBackText: PropTypes.bool,
  headerImage: PropTypes.string,
  handleBack: PropTypes.func,
};

export default Header;
